<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>
      Üzenetek
      <ion-badge color="danger" *ngIf="olvasatlan">{{ olvasatlan }}</ion-badge>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="ujNyitva = true" *ngIf="irhat.length">
        <ion-icon slot="start" name="create-outline"></ion-icon>Új üzenet
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!--  EGY KÁRTYA, HÁROM HELYEN: a beérkezett üzenetnél, az új levél szerkesztőjében és
        a válaszmezőnél. Ugyanaz a doboz — ezért egy sablon, nem három másolat. -->
  <ng-template #linkKartya let-e>
    <a class="link-kartya" [href]="e.url" target="_blank" rel="noopener noreferrer nofollow">
      <img class="lk-kep" *ngIf="e.kep" [src]="e.kep" alt="" referrerpolicy="no-referrer"
           loading="lazy" (error)="e.kep = null" />
      <span class="lk-test">
        <span class="lk-oldal">
          <img class="lk-ikon" *ngIf="e.ikon" [src]="e.ikon" alt="" referrerpolicy="no-referrer"
               loading="lazy" (error)="e.ikon = null" />
          {{ e.oldal }}
        </span>
        <b class="lk-cim">{{ e.cim }}</b>
        <span class="lk-leiras" *ngIf="e.leiras">{{ e.leiras }}</span>
      </span>
    </a>
  </ng-template>

  <ion-note color="medium" *ngIf="!irhat.length && !toltodik" style="display:block;padding:12px">
    Ezzel a szerepkörrel nem lehet üzenetet küldeni – a beérkezett üzenetek olvashatók.
  </ion-note>

  <div class="uzenet-grid">
    <!-- BAL: szálak -->
    <div class="szal-oszlop">
      <ion-input fill="outline" placeholder="Keresés a szálakban" [(ngModel)]="szuro"></ion-input>
      <ion-spinner name="crescent" *ngIf="toltodik"></ion-spinner>
      <div class="szal-lista">
        <div class="szal" *ngFor="let sz of szurtSzalak"
             [class.aktiv]="kivalasztott?.szal === sz.szal"
             [class.olvasatlan]="sz.olvasatlan" (click)="megnyit(sz)">
          <div class="szal-fej">
            <span class="targy">{{ sz.targy || '(tárgy nélkül)' }}</span>
            <ion-badge color="danger" *ngIf="sz.olvasatlan">{{ sz.olvasatlan }}</ion-badge>
          </div>
          <div class="elonezet">{{ sz.rendszer ? htmlNelkul(sz.utolso?.uzenet) : sz.utolso?.uzenet }}</div>
          <div class="meta">
            {{ sz.utolso?.kuldo_nev || sz.utolso?.kuldo }} · {{ sz.utolso?.created_at | date:'yyyy-MM-dd HH:mm' }}
            <span *ngIf="sz.uzenet_db > 1"> · {{ sz.uzenet_db }} üzenet</span>
            <span *ngIf="sz.cimke"> · {{ sz.cimke }}</span>
            <span *ngIf="sz.rendszer"> · rendszerüzenet</span>
          </div>
        </div>
        <div class="ures" *ngIf="!szurtSzalak.length && !toltodik">Nincs üzenet.</div>
      </div>
    </div>

    <!-- JOBB: a kiválasztott szál folyama -->
    <div class="folyam-oszlop">
      <ion-note color="medium" *ngIf="!kivalasztott">Válassz egy szálat a bal oldali listából.</ion-note>

      <div *ngIf="kivalasztott">
        <h3 style="margin:0 0 10px">{{ kivalasztott.targy }}</h3>

        <div class="folyam">
          <div class="buborek" *ngFor="let u of kivalasztott.uzenetek" [class.sajat]="sajat(u)">
            <div class="buborek-fej">
              <b>{{ u.kuldo_nev || u.kuldo }}</b>
              <span class="szerep" *ngIf="u.kuldo_mod">{{ tipusNev[u.kuldo_mod] || u.kuldo_mod }}</span>
              <span class="ido">{{ u.created_at | date:'yyyy-MM-dd HH:mm' }}</span>
              <!--  A JAVÍTÁS TÉNYE MINDENKINEK LÁTSZIK, nem csak a feladónak: a címzett
                    lehet, hogy az eredetit olvasta. -->
              <span class="szerkesztve" *ngIf="u.modositva"
                    [title]="'Javítva: ' + (u.modositva | date:'yyyy-MM-dd HH:mm')">szerkesztve</span>
              <ion-button class="buborek-szerkeszt" fill="clear" size="small" *ngIf="sajat(u) && szerkesztettId !== u.id"
                          (click)="szerkesztesInditasa(u)" title="Üzenet javítása" aria-label="Üzenet javítása">
                <ion-icon slot="icon-only" name="create-outline"></ion-icon>
              </ion-button>
            </div>
            <!--  A szöveg SOHA nem megy át HTML-ként: darabokra bontva rajzoljuk ki,
                  és csak a linkből lesz hivatkozás. Így egy üzenetbe írt <script> a
                  képernyőn is az marad, ami: szöveg. -->
            <!--  SZERKESZTÉS: a buborék helyén szövegmező. Nem külön ablak – így látszik,
                  MELYIK üzenetet javítjuk, és mi van körülötte a szálban. -->
            <div class="szerkeszto" *ngIf="szerkesztettId === u.id">
              <ion-textarea fill="outline" [autoGrow]="true" rows="3"
                            [(ngModel)]="szerkesztettSzoveg"></ion-textarea>
              <div class="szerkeszto-sor">
                <ion-note color="medium" *ngIf="u.olvasta_db">
                  Már {{ u.olvasta_db }} címzett elolvasta.
                </ion-note>
                <span class="tolto"></span>
                <ion-button size="small" fill="clear" color="medium" (click)="szerkesztesMegse()">Mégse</ion-button>
                <ion-button size="small" color="primary" [disabled]="szerkesztesFolyamatban"
                            (click)="szerkesztesMentes(u)">Mentés</ion-button>
              </div>
            </div>

            <!--  RENDSZERÜZENET (a rendszer küldte: riasztás, fizetés-visszaigazolás): HTML-ben készül,
                  ezért HTML-ként jelenik meg – az Angular tisztítójával (szkript, eseménykezelő, űrlap
                  nem megy át). Felhasználó üzenete SOSEM innerHTML (lásd szovegDarabok). -->
            <div class="szoveg rendszer-html" *ngIf="szerkesztettId !== u.id && u._html" [innerHTML]="u.uzenet"></div>
            <div class="szoveg" *ngIf="szerkesztettId !== u.id && !u._html"><ng-container *ngFor="let d of u._darabok"><a
                  *ngIf="d.url; else sima" [href]="d.url" target="_blank"
                  rel="noopener noreferrer nofollow">{{ d.text }}</a><ng-template
                  #sima>{{ d.text }}</ng-template></ng-container></div>

            <!--  LINK-KÁRTYA. A címzett lássa, hová kattint, mielőtt kattintana. Az
                  adatokat a kiszolgáló kéri le (link-elonezet.js), nem a böngésző. -->
            <ng-container *ngIf="u._link && elonezet(u._link) as e"
                          [ngTemplateOutlet]="linkKartya" [ngTemplateOutletContext]="{ $implicit: e }">
            </ng-container>

            <div class="csatolmanyok" *ngIf="u.csatolmanyok?.length">
              <ng-container *ngFor="let cs of u.csatolmanyok">
                <!--  A videót helyben lehet megnézni: egy értekezlet-felvétel letöltve
                      több száz megabájt, és a címzett többnyire csak bele akar nézni.
                      A lejátszó tekerni is tud (a kiszolgáló részleteket ad). -->
                <div class="csatolt-video" *ngIf="videoE(cs); else fajlLink">
                  <video *ngIf="videoCim(cs) as cim" [src]="cim" controls preload="metadata"></video>
                  <div class="cv-sor">
                    <span>{{ cs.fajlnev }} <span class="meret">{{ meret(cs.meret) }}</span></span>
                    <span class="tolto"></span>
                    <a (click)="fajlNyit(csatolmanyLetoltesUrl(cs), cs.fajlnev)">
                      <ion-icon name="download-outline"></ion-icon> Letöltés
                    </a>
                    <a class="csatolmany-x" *ngIf="sajat(u)" (click)="csatolmanyTorles(u, cs)"
                       title="Csatolmány visszavétele">
                      <ion-icon name="close-circle-outline"></ion-icon> Visszavesz
                    </a>
                  </div>
                </div>
                <ng-template #fajlLink>
                  <span class="csatolmany-sor">
                    <a (click)="fajlNyit(csatolmanyUrl(cs), cs.fajlnev)" class="csatolmany">
                      <ion-icon name="document-attach-outline"></ion-icon>
                      {{ cs.fajlnev }} <span class="meret">{{ meret(cs.meret) }}</span>
                    </a>
                    <!--  Visszavenni csak a feladó tud, és csak a saját leveléről. -->
                    <span class="csatolmany-x" *ngIf="sajat(u)" (click)="csatolmanyTorles(u, cs)"
                          title="Csatolmány visszavétele">×</span>
                  </span>
                </ng-template>
              </ng-container>
            </div>
            <!-- Kevés címzettnél a nevek is elférnek; sok esetén csak a darabszám. -->
            <div class="cimzettek" *ngIf="sajat(u) && u.cimzettek?.length">
              Címzett:
              <span *ngIf="u.cimzettek.length <= 4">
                <span *ngFor="let c of u.cimzettek; let i = index">{{ i ? ', ' : '' }}{{ c.nev || c.user }}</span>
              </span>
              <span *ngIf="u.cimzettek.length > 4">{{ u.cimzettek.length }} fő</span>
            </div>
          </div>
        </div>

        <!-- Rendszerüzenetre nincs válasz: nincs mögötte postafiók. Kimondjuk,
             nem csak elrejtjük a mezőt – különben úgy tűnne, elromlott valami. -->
        <div class="rendszer-jelzes" *ngIf="kivalasztott.rendszer">
          <ion-icon name="information-circle-outline"></ion-icon>
          Ezt az üzenetet a rendszer küldte automatikusan – nem lehet rá válaszolni.
          Ha kérdésed van, írj a megfelelő munkatársnak új üzenetben.
        </div>

        <!-- Válasz: nincs címzett-választó, a szál résztvevői kapják (szerepkör szerint szűrve) -->
        <div class="valasz-doboz" *ngIf="irhat.length && kivalasztott.valaszolhato">
          <!-- Több résztvevős szálnál eldönthető, kinek megy a válasz. Egy embernél
               nincs mit választani, ott a sáv el is marad. -->
          <div class="valasz-cimzes" *ngIf="tobbResztvevo">
            <span class="cimke">Válasz címzettje:</span>
            <label><input type="radio" name="vmod" [checked]="valaszMod === 'mind'"
                          (change)="valaszMod = 'mind'" /> Mindenkinek ({{ valaszJeloltek.length }})</label>
            <label *ngIf="kivalasztott.felado">
              <input type="radio" name="vmod" [checked]="valaszMod === 'felado'"
                     (change)="valaszMod = 'felado'" />
              Csak a feladónak<span *ngIf="kivalasztott.felado_nev"> ({{ kivalasztott.felado_nev }})</span>
            </label>
            <label><input type="radio" name="vmod" [checked]="valaszMod === 'valasztott'"
                          (change)="valaszMod = 'valasztott'" /> Kiválasztottaknak</label>
          </div>
          <div class="valasz-valaszto" *ngIf="tobbResztvevo && valaszMod === 'valasztott'">
            <label class="jelolt" *ngFor="let j of valaszJeloltek">
              <input type="checkbox" [checked]="valaszValasztottak.includes(j.azonosito)"
                     (change)="valasztottValt(j.azonosito, $any($event.target).checked)" />
              {{ j.nev }}
              <span class="tip" *ngIf="j.tipus">{{ tipusNev[j.tipus] || j.tipus }}</span>
            </label>
          </div>

          <ion-textarea fill="outline" label="Válasz" labelPlacement="stacked" [autoGrow]="true"
                        rows="3" [(ngModel)]="valasz" (ionInput)="linkFigyel('valasz')"
                        placeholder="Írd ide a választ…"></ion-textarea>
          <!--  Amit a címzett látni fog – még küldés előtt. -->
          <ng-container *ngIf="valaszLink && elonezet(valaszLink) as e"
                        [ngTemplateOutlet]="linkKartya" [ngTemplateOutletContext]="{ $implicit: e }">
          </ng-container>
          <div class="fajl-sor">
            <label class="fajl-gomb">
              <ion-icon name="attach-outline"></ion-icon> Fájl csatolása
              <input type="file" multiple (change)="fajlValaszt($event, 'valasz')" hidden />
            </label>
            <span class="fajl-chip" *ngFor="let f of valaszCsatolando">
              {{ f.name }} <span class="x" (click)="fajlTorol(f, 'valasz')">×</span>
            </span>
            <ion-button size="small" color="primary" (click)="valaszKuld()" [disabled]="kuldes">
              <ion-icon slot="start" name="send-outline"></ion-icon>
              Válasz küldése<span *ngIf="tobbResztvevo"> – {{ valaszCimkeSzoveg }}</span>
            </ion-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Új üzenet -->
  <ion-modal [isOpen]="ujNyitva" (didDismiss)="ujNyitva = false">
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-title>Új üzenet</ion-title>
          <ion-buttons slot="end"><ion-button (click)="ujNyitva = false">Bezár</ion-button></ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <!--  KÉT CSATORNA, ÉS NEM UGYANAZ A KETTŐ.
              A belső üzenet a rendszeren belül marad. A hivatali kapu HIVATALOS küldés a
              szervezet nevében, érkeztetési számmal – ezért csak adminisztrátornak, és
              ezért kér dokumentumot: azt továbbítja, nem szöveget. -->
        <ion-segment *ngIf="admin" [(ngModel)]="csatorna" (ionChange)="csatorna === 'hivatali_kapu' && hkPartnerekBetolt()"
                     style="margin-bottom:10px">
          <ion-segment-button value="belso"><ion-label>Belső üzenet</ion-label></ion-segment-button>
          <ion-segment-button value="hivatali_kapu"><ion-label>Hivatali kapu</ion-label></ion-segment-button>
        </ion-segment>

        <!-- ══════════ HIVATALI KAPU ══════════ -->
        <ng-container *ngIf="admin && csatorna === 'hivatali_kapu'">
          <ion-note color="medium" style="display:block;font-size:12px;margin-bottom:8px">
            Hivatalos küldés a szervezet nevében, a <b>BKSZ gépi csatornáján</b>. A hivatali kapu
            <b>dokumentumot</b> továbbít (jellemzően aláírt PDF-et), nem szöveget — a tárgy és a
            csatolt fájl megy át. A sikeres feladás <b>érkeztetési számot</b> kap, és bekerül a
            postakönyvbe. A csatornát az <b>Iktatgató → BKSZ</b> képernyőn kell beállítani.
          </ion-note>

          <ion-input fill="outline" label="Címzett keresése a partnertörzsből" labelPlacement="stacked"
                     placeholder="Név, KRID vagy rövid név – üresen az egész törzs látszik"
                     [(ngModel)]="hkPartnerSzuro"></ion-input>
          <div class="talalat-lista" *ngIf="hkPartnerek.length">
            <div class="talalat" *ngFor="let p of hkPartnerLista"
                 [class.kivalasztott]="hk.partner_id === p.id"
                 (click)="hk.partner_id = p.id; hk.krid = ''; hk.cimzett_rovidnev = '';
                          hk.kapcsolati_kod = ''">
              <span>
                <ion-badge [color]="hkCimezheto(p) ? 'success' : 'medium'">
                  {{ p.tipus === 'szemely' ? 'személy' : 'szervezet' }}
                </ion-badge>
                {{ p.nev }}
                <span class="alsor"> · {{ hkPartnerAllapot(p) }}</span>
              </span>
              <ion-icon [name]="hk.partner_id === p.id ? 'checkmark-circle' : 'checkmark-circle-outline'"></ion-icon>
            </div>
          </div>
          <ion-note color="medium" *ngIf="!hkPartnerek.length" style="display:block;font-size:11.5px;margin:6px 0">
            A partnertörzs üres. Címzett felvehető az <b>Iktatgató → Partnertörzs</b> képernyőn, vagy
            add meg alább közvetlenül a hivatali kapu rövid nevét, a KRID-et vagy a kapcsolati kódot.
          </ion-note>

          <ion-note color="medium" style="display:block;font-size:11.5px;margin:6px 0">
            Partner helyett közvetlenül is megcímezhető. Szervezetnek <b>hivatali kapu rövid
            névvel</b> vagy <b>KRID</b>-del, természetes személynek <b>kapcsolati kóddal</b> —
            a három kizárja egymást, egyszerre csak az egyiket töltsd ki. Ha nincs KRID-ed, a
            rövid név önmagában elég.
          </ion-note>
          <ion-input fill="outline" label="Hivatali kapu rövid név (szervezet)" labelPlacement="stacked"
                     [(ngModel)]="hk.cimzett_rovidnev"></ion-input>
          <ion-input fill="outline" label="KRID (szervezet)" labelPlacement="stacked"
                     [(ngModel)]="hk.krid" style="margin-top:8px"></ion-input>
          <ion-input fill="outline" label="Kapcsolati kód (természetes személy)" labelPlacement="stacked"
                     [(ngModel)]="hk.kapcsolati_kod" style="margin-top:8px"></ion-input>

          <ion-input fill="outline" label="Tárgy" labelPlacement="stacked" [(ngModel)]="hk.targy"
                     style="margin-top:10px"></ion-input>
          <ion-input fill="outline" label="Hivatkozási / iktatószám (elhagyható)" labelPlacement="stacked"
                     [(ngModel)]="hk.iktatoszam" style="margin-top:8px"></ion-input>

          <div class="fajl-sor" style="margin-top:10px">
            <label class="fajl-gomb">
              <ion-icon name="attach-outline"></ion-icon> Dokumentum csatolása
              <input type="file" (change)="hkFajlValaszt($event)" hidden />
            </label>
            <span class="fajl-chip" *ngIf="hkFajl">{{ hkFajl.name }}</span>
          </div>

          <div class="hk-eredmeny" *ngIf="hkEredmeny" [class.baj]="!hkEredmeny.ok">
            {{ hkEredmeny.szoveg }}
          </div>

          <ion-button expand="block" color="success" style="margin-top:14px"
                      (click)="kuldHivataliKapu()" [disabled]="kuldes">
            <ion-icon slot="start" name="send-outline"></ion-icon>
            {{ kuldes ? 'Feladás…' : 'Feladás a hivatali kapun' }}
          </ion-button>
        </ng-container>

        <!-- ══════════ BELSŐ ÜZENET ══════════ -->
        <ng-container *ngIf="!admin || csatorna === 'belso'">
        <ion-note color="medium" style="display:block;font-size:12px;margin-bottom:8px">
          Kinek írhatsz:
          <b><span *ngFor="let t of irhat; let i = index">{{ i ? ', ' : '' }}{{ tipusNev[t] || t }}</span></b>.
          Osztálynak vagy csoportnak küldve mindenki külön kapja meg, és külön is válaszol.
        </ion-note>

        <!--  MEGOSZTOTT FELVÉTEL. Az Értekezlet képernyőről érkezett; a küldés után
              hivatkozásként kerül a levélre, másolat nem készül róla. -->
        <div class="megosztott-felvetel" *ngIf="megosztandoFelvetel">
          <ion-icon name="videocam-outline"></ion-icon>
          <span>
            <b>Csatolva: {{ megosztandoFelvetel.szoba }}</b>
            <small>
              Értekezlet-felvétel<span *ngIf="megosztandoFelvetel.meret"> · {{ meret(megosztandoFelvetel.meret) }}</span>.
              A címzettek itt, a rendszerben nézik vissza – a fájl nem másolódik le.
            </small>
          </span>
          <ion-button fill="clear" size="small" color="medium" (click)="felvetelMegosztasElvet()">
            Elvet
          </ion-button>
        </div>

        <div class="cimzett-lista">
          <span class="cimzett-chip" *ngFor="let c of uj.cimzettek">
            <b>{{ tipusNev[c.tipus] }}:</b> {{ c.nev || c.azonosito }}
            <span class="db" *ngIf="c.db"> ({{ c.db }})</span>
            <span class="x" (click)="cimzettKivesz(c)">×</span>
          </span>
        </div>

        <!--  EGY VÁLASZTÓ MINDENRE. A körök („Minden gondviselő", „5.z – szülők") ugyanitt
              kereshetők, mint a nevek; üres mezővel a lista a köröket kínálja fel, hogy
              egyáltalán tudni lehessen róluk. Névre a szokásos két karaktertől keres. -->
        <ion-input fill="outline" label="Címzett keresése" labelPlacement="stacked"
                   placeholder="Kör vagy név – írd be: szülők, 5.z, mindenki, vagy egy nevet"
                   [(ngModel)]="cimzettKereses"></ion-input>
        <div class="talalat-lista" *ngIf="talalatok.length">
          <div class="talalat" *ngFor="let t of talalatok" (click)="cimzettHozzaad(t)"
               [class.talalat--kor]="t.db">
            <span>
              <ion-badge [color]="t.db ? 'warning' : 'medium'">{{ tipusNev[t.tipus] }}</ion-badge>
              {{ t.nev || t.azonosito }}
              <span class="alsor" *ngIf="t.db"> · {{ t.db }} fő</span>
              <span class="alsor" *ngIf="t.osztaly"> · {{ t.osztaly }}</span>
              <span class="alsor" *ngIf="t.gyermekek"> · {{ t.gyermekek }}</span>
              <span class="alsor" *ngIf="t.ev"> · {{ t.ev }}</span>
              <span class="alsor" *ngIf="t.leiras"> · {{ t.leiras }}</span>
            </span>
            <ion-icon name="add-circle-outline"></ion-icon>
          </div>
        </div>
        <ion-note color="medium" class="kor-magyarazat" *ngIf="!intezmenyiKor && cimtar?.kor?.length">
          Az egész iskolának szóló körökhöz (Mindenki, Minden gondviselő) adminisztrátori
          jogosultság kell – az <b>Adminisztrátori jogosultságok → Üzenetek</b> területen adható meg.
        </ion-note>

        <ion-input fill="outline" label="Tárgy" labelPlacement="stacked" [(ngModel)]="uj.targy"
                   style="margin-top:10px"></ion-input>
        <ion-textarea fill="outline" label="Üzenet" labelPlacement="stacked" [autoGrow]="true"
                      rows="6" [(ngModel)]="uj.uzenet" (ionInput)="linkFigyel('uj')"
                      style="margin-top:10px"></ion-textarea>
        <!--  Amit a címzett látni fog – még küldés előtt. Elég beírni a címet
              („zenitiskola.hu” is jó, séma nélkül); a kártya pár pillanattal később jelenik meg. -->
        <ng-container *ngIf="ujLink && elonezet(ujLink) as e"
                      [ngTemplateOutlet]="linkKartya" [ngTemplateOutletContext]="{ $implicit: e }">
        </ng-container>

        <div class="fajl-sor" style="margin-top:10px">
          <label class="fajl-gomb">
            <ion-icon name="attach-outline"></ion-icon> Fájl csatolása
            <input type="file" multiple (change)="fajlValaszt($event, 'uj')" hidden />
          </label>
          <span class="fajl-chip" *ngFor="let f of csatolando">
            {{ f.name }} <span class="x" (click)="fajlTorol(f, 'uj')">×</span>
          </span>
        </div>

        <ion-button expand="block" color="success" style="margin-top:14px"
                    (click)="kuld()" [disabled]="kuldes">
          <ion-icon slot="start" name="send-outline"></ion-icon>
          Küldés<span *ngIf="becsultCimzettDb"> – {{ becsultCimzettDb }} címzett</span>
        </ion-button>
        </ng-container>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
